import { useState, type FC } from "react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";

interface DeviceOption {
  id: string;
  name: string;
  icon: string;
}

const AppDevicesPage: FC = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>("Fitbit");

  const deviceOptions: DeviceOption[] = [
    {
      id: "fitbit",
      name: "Fitbit",
      icon: new URL("../../assets/fitbit.png", import.meta.url).href,
    },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 p-4">
          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-500">
              Bite Balance
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <div className="mb-8 space-y-2 text-center">
            <h1 className="text-3xl font-bold text-foreground sm:text-4xl">
              App & Devices
            </h1>
            <p className="text-lg text-muted-foreground">
              Link Your Favorite App Or Device
            </p>
          </div>

          <div className="space-y-3">
            {deviceOptions.map(device => (
              <Card
                key={device.id}
                onClick={() => setSelected(device.name)}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === device.name
                    ? "border-primary bg-primary/5"
                    : "border-border hover:border-primary/50"
                }`}
              >
                <div className="flex items-center gap-4">
                  <img
                    src={device.icon}
                    alt={device.name}
                    className="h-12 w-12 rounded-xl object-contain"
                  />
                  <span className="flex-1 text-lg font-medium text-foreground">
                    {device.name}
                  </span>
                  <div
                    className={`flex h-5 w-5 items-center justify-center rounded-full border-2 ${
                      selected === device.name
                        ? "border-primary bg-primary"
                        : "border-muted-foreground"
                    }`}
                  >
                    {selected === device.name && (
                      <div className="h-2 w-2 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={() => {
              if (selected) {
                navigate(
                  "/glucera" + GluceraNavigationRoutes.fitbitConnectionPage
                );
              }
            }}
            className="h-11 w-full rounded-xl bg-gradient-primary text-sm hover:opacity-90 sm:h-12 sm:text-base"
          >
            {selected ? "Next" : "Select Device"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppDevicesPage;
